import axios from "./axios";

//注册时获取短信验证码
// export function getCodeOnRegist(options) {
//     return axios.post('/api/v1/web/register/mobile/login/code',options);
// }

// //短信注册
// export function messageToRegist(options){
//     return axios.post('/api/v1/web/register/sms/login',options);
// }
//获取用户信息
export function getUserInfoData (options) {
  return axios.get('/api/v1/web/auth/get_info', options, {
    headers: {
      "Authorization": options.token
    }
  });
}

//完善用户信息
export function perfectPersonInfo (options) {
  return axios.post('/api/v1/web/auth/per_info', options, {
    headers: {
      "Content-Type": "application/json"
    }
  })
}

//完善信息--发送短信验证码
export function perfectPersonCode (options) {
  return axios.get('/api/v1/web/register/wechat/bind/code?phone=' + options.phone);
}

//微信登录，发送code
export function sendCodeToLogin (options) {
  return axios.get('/api/v1/web/register/wechat/login?code=' + options.code + '&state=' + options.state);
}
//微信绑定，携带token
export function sendCodeToBind (options) {
  return axios.get('/api/v1/web/register/wechat/bind?code=' + options.code + '&state=' + options.state);
}
